// Filter Types
export const FILTER_TYPE_BOOLEAN = 'FILTER_TYPE_BOOLEAN';
export const FILTER_TYPE_LIST = 'FILTER_TYPE_LIST';
export const FILTER_TYPE_STRING = 'FILTER_TYPE_STRING';

export interface ExistenceCheckType {
  (params: boolean): boolean;
  (params: string[]): boolean;
}

export const FILTER_KEYS = {
  is_landscape: {
    label: 'Landscape',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  is_portrait: {
    label: 'Portrait',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  featured_artist: {
    label: 'Designs by Featured Artists',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  has_foil: {
    label: 'Foil Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  has_custom_photo: {
    label: 'Designs with Photos',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  has_no_custom_photo: {
    label: 'No Photos',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  has_magnet: {
    label: 'Designs for Magnets',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  is_vow_renewal: {
    label: 'Reception Only Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  is_letterpress: {
    label: 'Letterpress Designs',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
  multiColor: {
    label: '',
    defaultValue: [] as string[],
    filterType: FILTER_TYPE_LIST,
  },
  motifs: {
    label: '',
    defaultValue: [] as string[],
    filterType: FILTER_TYPE_LIST,
  },
  silhouettes: {
    label: '',
    defaultValue: [] as string[],
    filterType: FILTER_TYPE_LIST,
  },
  seo_colors: {
    label: '',
    defaultValue: [] as string[],
    filterType: FILTER_TYPE_LIST,
  },
  sorts: {
    label: '',
    defaultValue: [] as string[],
    filterType: FILTER_TYPE_LIST,
  },
};

export const SEARCH_FILTER_KEYS = {
  ...FILTER_KEYS,
  has_digital: {
    label: '',
    defaultValue: false,
    filterType: FILTER_TYPE_BOOLEAN,
  },
};

export const MORE_FILTER_LIST_MOBILE = [
  'has_magnet',
  'has_custom_photo',
  'has_no_custom_photo',
  'has_foil',
  'is_letterpress',
  'is_vow_renewal',
  'is_landscape',
  'is_portrait',
  'featured_artist',
];

export const MORE_FILTER_LIST_DESKTOP = ['is_landscape', 'is_portrait', 'featured_artist'];
